import type { FC, ReactNode } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Button, Typography } from '@mui/material';

import { styles } from './ticketDetail.styles';

interface ModalSectionProps {
  header?: string;
  extendable?: {
    extended: boolean;
    toggleExtended: () => void;
  };
  children?: ReactNode;
}

const ModalSection: FC<ModalSectionProps> = ({
  children,
  header,
  extendable,
}) => (
  <Box
    component="section"
    aria-label={header}
    sx={[{ gap: 2 }, styles.modalSection]}
  >
    {header && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {extendable ? (
          <Button
            variant="ctaSecondary"
            component="h4"
            id="header"
            onClick={extendable.toggleExtended}
            sx={(theme) => ({ px: 0, ...theme.typography.h6 })}
            endIcon={
              extendable.extended ? (
                <KeyboardArrowUpIcon
                  sx={(theme) => ({
                    color: theme.colors.primary[600],
                    fontSize: '1.5rem!important',
                  })}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={(theme) => ({
                    color: theme.colors.primary[600],
                    fontSize: '1.5rem!important',
                  })}
                />
              )
            }
          >
            {header}
          </Button>
        ) : (
          <Typography variant="h6" component="h4">
            {header}
          </Typography>
        )}
      </Box>
    )}

    {(!extendable || extendable.extended) && children}
  </Box>
);

export default ModalSection;
